import React, { useState } from "react";
// import { Link } from "react-router-dom";
import "../../index.scss";

//Images
import gardenbeds1 from "../../../images/categories/gardenbeds/PPI-garden-bed-001.jpg";
import gardenbeds2 from "../../../images/categories/gardenbeds/PPI-garden-bed-002.jpg";
import gardenbeds3 from "../../../images/categories/gardenbeds/PPI-garden-bed-003.jpg";
import gardenbeds4 from "../../../images/categories/gardenbeds/PPI-garden-bed-004.jpg";
import gardenbeds5 from "../../../images/categories/gardenbeds/PPI-garden-bed-005.jpg";
import gardenbeds6 from "../../../images/categories/gardenbeds/PPI-garden-bed-006.jpg";
import gardenbeds7 from "../../../images/categories/gardenbeds/PPI-garden-bed-007.jpg";
import gardenbeds8 from "../../../images/categories/gardenbeds/PPI-garden-bed-008.jpg";
import gardenbeds9 from "../../../images/categories/gardenbeds/PPI-garden-bed-009.jpg";
import gardenbeds10 from "../../../images/categories/gardenbeds/PPI-garden-bed-010.jpg";
import gardenbeds12 from "../../../images/categories/gardenbeds/PPI-garden-bed-012.jpg";
import gardenbeds13 from "../../../images/categories/gardenbeds/PPI-garden-bed-013.jpg";
import gardenbeds14 from "../../../images/categories/gardenbeds/PPI-garden-bed-014.jpg";

//Utils
import { mapGallery } from "../../../../../Utils/Utils";

//Panels
import Modal from "../../../Modal/Modal";

//SEO
import SEO from ".././../../../../SEO/index";
import StructuredData from "../../../../../SEO/structuredData";

const GardenBeds = () => {
  const [showModal, setShowModal] = useState(false);
  const [current, setCurrent] = useState(0);

  const images = [
    {
      image: gardenbeds1,
      description:
        "Modern retaining wall made from poured concrete and stucco. This wall is holding up a drought tolerant desert landscape garden bed.",
      aria: "Retaining wall holding up a drought tolerant desert landscape garden bed",
    },
    {
      image: gardenbeds2,
      description:
        "Modern retaining wall with gas fire bowl accent. The exterior of the wall was painted sage green to blend with the landscaping and add a pop of color.",
      aria: "Retaining wall with gas fire bowl accent and outdoor couches",
    },
    {
      image: gardenbeds3,
      description:
        "Garden wall with built-in pool water feature. This garden wall serves a functional purpose by keeping the slope at bay while also adding an opportunity to create some pool accent landscaping.",
      aria: "Garden wall with built-in pool water feature with plants in background",
    },
    {
      image: gardenbeds4,
      description:
        "Curved pool retaining wall and drought-tolerant garden bed. The wall was finished with sand colored tiles to match the pool deck and patio.",
      aria: "Inground pool and spa surrounded by plants, lawn, and basketball hoop",
    },
    {
      image: gardenbeds5,
      description:
        "Multi-tiered garden walls with fire bowl accent on tiled podium. The stucco of this retaining wall was created in the same colorway as the paving stone deck to create a cohesive design.",
      aria: "Multi-tiered garden walls with fire bowl accent on tiled podium",
    },
    {
      image: gardenbeds6,
      description:
        "Raised garden beds with ornamental tiling. These raised planter beds were created for this Los Angeles home to add some style and sophistication to at-home gardening.",
      aria: "Raised garden beds with ornamental tiling in Los Angeles property",
    },
    {
      image: gardenbeds7,
      description:
        "Raised garden beds with large lavender bushes. Adding a raised garden bed can add depth and dimension to an outdoor space.",
      aria: "Raised garden beds with large lavender bushes surrounded by stone",
    },
    {
      image: gardenbeds8,
      description:
        "Curved wall made from tumbled paving stones with a slate stone top. We wanted to segment the dining area of this Santa Clarita home in a way that enhanced the rustic, farmhouse style the rest of the design was in.",
      aria: "Curved wall made from tumbled paving stones with a slate stone top on Santa Clarita property",
    },
    {
      image: gardenbeds9,
      description:
        "Outdoor retaining wall that stretches the entire backyard and holds back a natural slope to create more usability out of the space. This retaining wall also frames out a corner space for a custom outdoor kitchen.",
      aria: "Outdoor retaining wall that frames out a corner space for a custom outdoor kitchen",
    },
    {
      image: gardenbeds10,
      description:
        "Three-foot retaining wall with large fire and water feature built in.",
      aria: "Three-foot retaining wall with large fire and water feature built in",
    },
    {
      image: gardenbeds12,
      description:
        "Short garden wall that wraps around the entire backyard area. Sprayed white stucco with rustic stone accent on top.",
      aria: "Short garden wall that wraps around backyard area with fire pit and outdoor furniture",
    },
    {
      image: gardenbeds13,
      description:
        "Garden bed and tiered walkway wall with large round stone accents. This Los Angeles hardscape project expands across multiple elevations and features multiple garden beds, retaining walls and fire features throughout.",
      aria: "Garden bed and tiered walkway wall with round stone accents and retaining walls and fire features",
    },
    {
      image: gardenbeds14,
      description:
        "Retaining walls made from Concrete and large natural stones with custom steps made from the same material. Artificial turf rounds out this design to create a manicured english garden design.",
      aria: "Retaining walls made from Concrete & large natural stones with steps surrounded by artificial turf",
    },
  ];

  return (
    <>
      <SEO
        title="Garden Retaining Wall Ideas | Los Angeles | Pacific Pavingstone"
        description="View the beautiful garden retaining wall projects we've completed in Southern California. Gain inspiration and ideas for your next project today!"
        profileURL={"https://www.pacificpavingstone.com/gallery/garden-walls"}
        type="website"
      />
      <StructuredData
        orgaCreator={{
          "@context": "https://schema.org",
          "@type": "ImageGallery",
          name: "Completed Garden Retaining Wall Gallery",
          description:
            "View the beautiful garden retaining wall projects we've completed in Southern California. Gain inspiration and ideas for your next project today!",
          image:
            "https://www.pacificpavingstone.com/static/media/PPI-garden-bed-002.1cc94ed7.jpg",
          URL: "https://www.pacificpavingstone.com/contact-us",
        }}
      />
      <div className="container-fluid no-side-padding gallery-wrapper">
        <div className="row justify-content-center">
          <div className="col-11">
            <div className="row gallery-images">
              {mapGallery(images, "landscape", setShowModal, setCurrent)}
            </div>
          </div>
        </div>
        <Modal
          show={showModal}
          onHide={() => setShowModal(false)}
          items={images}
          current={current}
        />
      </div>
    </>
  );
};

export default GardenBeds;
